import Box from '@mui/material/Box';
import { Form, useTranslate } from 'react-admin';
import RadioButtonInputWithLabelOnTop from '@/components/common/forms/common/radio-button-input-with-label-on-top/radio-button-input-with-label-on-top';
import TextInputWithLabels from '@/components/common/forms/common/text-input-with-labels/text-input-with-labels';
import ImageInputWithLabelOnTop from '@/components/common/forms/common/image-input-with-label-on-top/image-input-with-label-on-top';

const formId = '_form_maintenance_curative_pianotage_1';

const refactorCheckboxData = (data: any) => {
    let newData = { ...data };

    if ('env_sensible_checkbox_group' in data) {
        if (newData['env_sensible_checkbox_group']['yes'] === true) {
            newData['env_sensible_checkbox_group'] = 'yes';
        } else if (newData['env_sensible_checkbox_group']['no'] === false) {
            newData['env_sensible_checkbox_group'] = 'no';
        } else {
            newData['env_sensible_checkbox_group'] = undefined;
        }
    }

    return newData;
};

interface Props {
    readOnly?: boolean;
    defaultValues?: (formId: string) => {};
}

const PianageForm = ({ readOnly = false, defaultValues = (_formId: string): any => {} }: Props) => {
    const translate = useTranslate();

    return (
        <Form defaultValues={refactorCheckboxData(defaultValues(formId))}>
            <Box
                sx={{
                    display: 'grid',
                    gap: 2,
                    p: 1,
                }}
            >
                <RadioButtonInputWithLabelOnTop
                    source={'env_sensible_checkbox_group'}
                    label={'Stockage ou environnement sensible:'}
                    readOnly={readOnly}
                />

                <TextInputWithLabels
                    topLabel={translate('forms.cogri')}
                    rightLabel={'ML'}
                    source='CogriML'
                    readOnly={readOnly}
                />

                <TextInputWithLabels
                    topLabel={translate('forms.meta')}
                    rightLabel={'U'}
                    source='MethaU'
                    readOnly={readOnly}
                />

                <ImageInputWithLabelOnTop label={translate('forms.image_label')} source='media' readOnly={readOnly} />

                <TextInputWithLabels
                    topLabel={translate('forms.localization_label')}
                    source='Localisation'
                    readOnly={readOnly}
                />
            </Box>
        </Form>
    );
};

export default PianageForm;
